/**
 * PersonaRow — JSX copied verbatim from
 * designs/edit-with-ai-combined-6-9.html lines 122-150.
 *
 * Renders a single persona in the sidebar and bottom sheet. Shows icon
 * square + name + TEAM badge + description + pinned star. When `selected`
 * (the chat is locked on this persona), the row gets a ube-tinted
 * background + ring and the trailing star is replaced with 🔒.
 */

import type { PersonaListItem } from '../../types/personas';

export interface PersonaRowProps {
  p: PersonaListItem;
  selected: boolean;
  locked: boolean;
  onClick: () => void;
}

export function PersonaRow({ p, selected, locked, onClick }: PersonaRowProps) {
  return (
    <button
      onClick={onClick}
      disabled={locked && !selected}
      className={`w-full text-left px-2 py-1.5 rounded-md transition-colors flex items-center gap-2 group ${
        selected
          ? 'bg-ube-100 ring-1 ring-ube-400 dark:bg-ube-900/30 dark:ring-ube-600'
          : locked
            ? 'opacity-40 cursor-not-allowed'
            : 'hover:bg-white dark:hover:bg-nightshade-800'
      }`}
    >
      <span
        className={`w-6 h-6 flex items-center justify-center rounded text-sm ${selected ? 'bg-white dark:bg-nightshade-800' : 'bg-nightshade-100 dark:bg-nightshade-800'}`}
      >
        {p.icon ?? '🪄'}
      </span>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1">
          <div className="text-xs font-medium text-nightshade-900 dark:text-nightshade-100 truncate">{p.name}</div>
          {p.visibility === 'team' && (
            <span className="text-[8px] px-1 py-0 bg-matcha-100 text-matcha-700 dark:bg-matcha-900/40 dark:text-matcha-300 rounded font-semibold">
              TEAM
            </span>
          )}
        </div>
        <div className="text-[10px] text-nightshade-500 dark:text-nightshade-400 truncate">{p.description}</div>
      </div>
      {selected ? (
        <span className="text-[10px] text-ube-700 dark:text-ube-400">🔒</span>
      ) : p.isPinned ? (
        <span className="text-[10px] text-lemon-400 dark:text-lemon-300" title="Pinned">
          ★
        </span>
      ) : null}
    </button>
  );
}

